<style scoped="scoped" lang="scss">
.gy-html {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
  border: none !important;
}

.gy-html /deep/ table {
  border-collapse: collapse;
  border-color: rgb(232, 232, 232);
}

.gy-html /deep/ table tbody tr:first-child {
  height: 26px;
  font-size: 12px;
  background: rgb(123, 127, 128);
}

.gy-html /deep/ table tbody tr:not(:first-child) {
  height: 26px;
  font-size: 12px;
  color: #606672;
}

// 全屏loading样式
.fullscreen-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-content {
  text-align: center;
  color: white;

  i {
    font-size: 32px;
    margin-bottom: 16px;
    display: block;
    animation: rotate 1s linear infinite;
  }

  p {
    font-size: 16px;
    margin: 0;
    color: #fff;
  }
}

// A4横向容器样式
.gykzpldc {
  width: 297mm;
  margin: 0 auto;
  background: white;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/craft/snapshot/export/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select type="equipmentAll" :queryFilter="e => e.belongId == null" :ids.sync="yt.conditions.equipmentId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('fashengshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.getBeginTime" :end.sync="yt.conditions.getEndTime"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('zhuangtai')">
            <el-select v-model="yt.conditions.status" clearable>
              <el-option :label="$t('daochuzhong')" value="0"></el-option>
              <el-option :label="$t('daochuchenggong')" value="1"></el-option>
              <el-option :label="$t('daochushibai')" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
      </template>

      <template #zhuangtai="scope">
        <el-tag v-if="scope.row.status === '0'">{{ $t('daochuzhong') }}</el-tag>
        <el-tag v-else-if="scope.row.status === '1'" type="success">{{ $t('daochuchenggong') }}</el-tag>
        <el-tag v-else="scope.row.status === '2'" type="danger">{{ $t('daochushibai') }}</el-tag>
      </template>
      <template #haoshi(miao)="scope">
        <span>{{ ((scope.row.updateTime - scope.row.createTime) / 1000).toFixed(0) }}</span>
      </template>

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="exportPdfBatch(scope.row)" :loading="exportPdfLoading" :disabled="scope.row.status !== '1'">{{ $t('xiazaipdf') }}</el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="exportExcelBatch(scope.row)" :loading="exportExcelLoading" :disabled="scope.row.status !== '1'">{{ $t('xiazaiexcel') }}</el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <div v-if="isPrinting">
      <div class="gykzpldc" id="gykzpldc">
        <div v-for="(item, index) in info.singleMonitorDatas" :key="index" :id="`page-${index}`" style="padding: 40px;box-sizing: border-box;width: 297mm;height: auto;margin: 0 auto;background: white;">
          <div style="display: flex;flex-wrap: nowrap;justify-content: center;align-items: center;font-size: 16px;font-weight: bold;margin-bottom: 5px;margin-top: -2px;">
            {{ store.state.organizations[0].name }}
          </div>
          <div style="height: 60px;overflow: hidden;display: flex;flex-direction: column;justify-content: center;">
            <div style="display: flex; flex-wrap: wrap; margin-bottom: 10px;">
              <div style="display: flex; align-items: center; width: 15%; margin-bottom: 8px;">
                <span style="font-weight: bold; margin-right: 8px; min-width: 80px;">{{ $t('shebeimingcheng') }}:</span>
                <span>{{ info.equipment.name }}</span>
              </div>
              <div style="display: flex; align-items: center; width: 40%; margin-bottom: 8px;">
                <span style="font-weight: bold; margin-right: 8px; min-width: 80px;">{{ $t('mohao') }}:</span>
                <span>{{ info.singleMonitorDatas[index].mouldNo }}</span>
              </div>
              <div style="display: flex; align-items: center; width: 20%; margin-bottom: 8px;">
                <span style="font-weight: bold; margin-right: 8px; min-width: 80px;">{{ $t('liaohao') }}:</span>
                <span>{{ info.singleMonitorDatas[index].materialNo }}</span>
              </div>
              <div style="display: flex; align-items: center; width: 25%; margin-bottom: 8px;">
                <span style="font-weight: bold; margin-right: 8px; min-width: 80px;">{{ $t('shengchanshijian') }}:</span>
                <span>{{ dayjs(info.singleMonitorDatas[index].time).format('YYYY-MM-DD HH:mm:ss') }}</span>
              </div>
            </div>
          </div>
          <div class="gy-html" v-html="gy(index)" v-watermark="watermarkText"></div>
        </div>
      </div>
    </div>

    <!-- 全屏loading -->
    <div v-if="fullscreenLoading" class="fullscreen-loading">
      <div class="loading-content">
        <i class="el-icon-loading"></i>
        <p>{{ progressText }}</p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';

export default {
  name: 'web_process_management_snapshot_export_list',
  data() {
    return {
      gyHtml: '',
      isPrinting: false,
      watermarkText: this.store.state.organizations[0].name + '-' + this.store.state.user.nickname,
      info: null,
      exportPdfLoading: false,
      exportExcelLoading: false,
      // 添加loading锁屏和进度相关数据
      fullscreenLoading: false,
      progressText: '',
      currentBatch: 0,
      totalBatches: 0,
      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'shebeiSN',
          prop: 'equipment.sn'
        },
        {
          label: 'fashengkaishishijian',
          prop: 'getBeginTime',
          type: 'time',
          width: 180
        },
        {
          label: 'fashengjieshushijian',
          prop: 'getEndTime',
          type: 'time',
          width: 180
        },
        {
          label: 'zhuangtai',
          prop: 'status',
          type: 'slot'
        },
        {
          label: 'haoshi(miao)',
          type: 'slot'
        },
        {
          label: 'caozuoren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'caozuoshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  directives: {
    watermark: {
      inserted(el, binding) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = 300;
        canvas.height = 200;
        ctx.font = '14px Arial';
        ctx.fillStyle = 'rgba(100, 100, 100, 0.3)'; // 水印颜色和透明度
        ctx.rotate((-20 * Math.PI) / 180); // 旋转角度
        let text = binding.value;
        if (text.length > 15) {
          let splitText = [];
          for (let i = 0; i < text.length; i += 15) {
            splitText.push(text.slice(i, i + 15));
          }
          text = splitText.join('\n');
        }
        // 保存初始的 y 坐标
        let y = 100;
        // 计算行高
        let lineHeight = parseInt(ctx.font, 10);
        // 增加行间距，这里设置为 5 像素
        let lineSpacing = 5;
        // 按行绘制文本并添加行间距
        text.split('\n').forEach((line, index) => {
          ctx.fillText(line, 50, y + index * (lineHeight + lineSpacing));
        });
        const imgData = canvas.toDataURL('image/png');
        el.style.backgroundImage = `url(${imgData})`;
        el.style.backgroundRepeat = 'repeat';
      }
    }
  },
  computed: {
    gy() {
      return (i) => {
        if (this.info == null) {
          return ""
        }

        try {
          let str = this.gyHtml;

          // 检查 gyHtml 是否为空或无效
          if (!str || typeof str !== 'string') {
            console.warn('gyHtml 为空或无效');
            return "";
          }

          // 添加 Base64 解码的错误处理
          try {
            str = this.safeBase64Decode(str);
          } catch (decodeError) {
            console.error('Base64 解码失败:', decodeError);
            console.log('原始 gyHtml:', str);
            // 如果解码失败，尝试直接使用原始字符串
            str = this.gyHtml;
          }

          let reg1 = /\[[^\]]*\]/g;
          str.match(reg1) &&
            str.match(reg1).map(code => {
              let c = code.replace('[', '');
              c = c.replace(']', '');
              str = str.replace(code, this.$t(c));
            });

          let reg2 = /\{[^\}]*\}/g;
          str.match(reg2) &&
            str.match(reg2).map(code => {
              let c = code.replace('{', '');
              c = c.replace('}', '');
              if (!this.store.state.eqPoints[this.info.equipmentId][c]) {
                console.log('gongyimobanqueshaodian' + ':' + c);
                return;
              }

              let value = this.info.singleMonitorDatas[i]['data'][c];

              if (value == null) {
                str = str.replace(code, '');
              } else {
                const dictTypeCode = this.store.state.eqPoints[this.info.equipmentId][c].dictTypeCode;
                if (dictTypeCode != null && dictTypeCode !== '') {
                  str = str.replace(code, this.$t(this.store.state.dictJsonAll[dictTypeCode][parseInt(value)]));
                } else {
                  let dataType = this.store.state.eqPoints[this.info.equipmentId][c].dataType;
                  if (dataType == 1) {
                    str = str.replace(code, value);
                  } else if (dataType == 3) {
                    str = str.replace(code, isNaN(Number(value)) ? value : Number(value).toFixed(0));
                  } else {
                    let prec = this.store.state.eqPoints[this.info.equipmentId][c].prec;
                    str = str.replace(code, isNaN(Number(value)) ? value : Number(value).toFixed(prec == null ? 2 : prec));
                  }
                }
              }
            });
          return str;
        } catch (error) {
          console.error('gy() 函数执行错误:', error);
          return "";
        }
      }
    }
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    /**
     * 计算自适应缩放尺寸
     * 根据内容宽高比与A4横向宽高比的比较来决定缩放策略
     * @param {number} contentWidth - 内容宽度（像素）
     * @param {number} contentHeight - 内容高度（像素）
     * @param {number} paperWidth - 纸张宽度（mm），默认A4横向297mm
     * @param {number} paperHeight - 纸张高度（mm），默认A4横向210mm
     * @param {number} margin - 边距（mm），默认10mm
     * @returns {object} 包含imgWidth, imgHeight, offsetX, offsetY的对象
     */
    calculateAdaptiveScale(contentWidth, contentHeight, paperWidth = 297, paperHeight = 210, margin = 10) {
      // 计算宽高比
      const paperRatio = paperWidth / paperHeight;
      const contentRatio = contentWidth / contentHeight;

      // 可用区域（减去边距）
      const availableWidth = paperWidth - (margin * 2);
      const availableHeight = paperHeight - (margin * 2);

      let imgWidth, imgHeight;

      if (contentRatio > paperRatio) {
        // 内容比纸张更宽，以宽度100%为准，高度按比例缩放
        imgWidth = availableWidth;
        imgHeight = availableWidth / contentRatio;

        // 确保高度不超过可用高度
        if (imgHeight > availableHeight) {
          imgHeight = availableHeight;
          imgWidth = availableHeight * contentRatio;
        }
      } else {
        // 内容比纸张更高，以高度100%为准，宽度按比例缩放
        imgHeight = availableHeight;
        imgWidth = availableHeight * contentRatio;

        // 确保宽度不超过可用宽度
        if (imgWidth > availableWidth) {
          imgWidth = availableWidth;
          imgHeight = availableWidth / contentRatio;
        }
      }

      // 计算居中位置
      const offsetX = (paperWidth - imgWidth) / 2;
      const offsetY = (paperHeight - imgHeight) / 2;

      return {
        imgWidth,
        imgHeight,
        offsetX,
        offsetY
      };
    },

    /**
     * 获取A4纸张尺寸常量
     * @returns {object} 包含各种A4纸张尺寸的对象
     */
    getA4Sizes() {
      return {
        PORTRAIT: {
          width: 210,
          height: 297
        },
        LANDSCAPE: {
          width: 297,
          height: 210
        }
      };
    },

    // 安全的 Base64 解码方法
    safeBase64Decode(str) {
      try {
        // 检查字符串是否为空
        if (!str || typeof str !== 'string') {
          return str;
        }

        // 检查是否是有效的 Base64 字符串
        const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
        if (!base64Regex.test(str)) {
          console.warn('字符串不是有效的 Base64 格式，直接返回原字符串');
          return str;
        }

        // 尝试解码
        return this.base64.decode(str);
      } catch (error) {
        console.error('Base64 解码失败:', error);
        console.log('原始字符串:', str);
        return str; // 返回原字符串
      }
    },

    // 批量导出Excel
    exportExcelBatch(row) {
      this.info = row;
      this.exportExcelLoading = true;
      this.fullscreenLoading = true;
      this.progressText = '正在获取工艺模板...';

      this.http.get('/web/craft/snapshot/export/template?equipmentId=' + row.equipmentId).then(res => {
        // 验证返回的数据
        if (!res.data || !res.data.gy) {
          this.$message.error('获取工艺模板失败：模板数据为空');
          this.fullscreenLoading = false;
          return;
        }

        this.gyHtml = res.data.gy;
        this.progressText = '正在解析监控数据...';

        // 验证 singleMonitorDatas 数据
        try {
          this.$set(this.info, 'singleMonitorDatas', JSON.parse(this.info.dataJson));
        } catch (parseError) {
          console.error('解析 dataJson 失败:', parseError);
          this.$message.error('解析监控数据失败');
          this.fullscreenLoading = false;
          return;
        }

        this.progressText = '正在生成Excel文件...';
        
        // 生成Excel文件
        this.generateExcelFile();

      }).catch(err => {
        console.error('获取工艺模板失败:', err);
        this.$message.error(this.$t(err));
        this.fullscreenLoading = false;
      }).finally(() => {
        this.exportExcelLoading = false;
      });
    },

    // 生成Excel文件
    generateExcelFile() {
      try {
        // 解析gyHtml获取表格模板和表头
        const templateData = this.parseHtmlTemplate();
        
        if (!templateData || templateData.length === 0) {
          this.$message.error('没有可导出的数据');
          this.fullscreenLoading = false;
          return;
        }

        // 为每个监控数据记录生成Excel行
        const excelData = this.generateExcelDataFromTemplate(templateData);
        
        if (!excelData || excelData.length === 0) {
          this.$message.error('没有可导出的数据');
          this.fullscreenLoading = false;
          return;
        }

        // 创建工作簿
        const wb = XLSX.utils.book_new();
        
        // 创建工作表
        const ws = XLSX.utils.aoa_to_sheet(excelData);
        
        // 设置列宽
        const colWidths = this.calculateColumnWidths(excelData);
        ws['!cols'] = colWidths;
        
        // 添加工作表到工作簿
        XLSX.utils.book_append_sheet(wb, ws, '工艺快照数据');
        
        // 生成文件名
        const fileName = `工艺快照_${this.info.equipment.name}_${new Date().getTime()}.xlsx`;
        
        // 导出文件
        XLSX.writeFile(wb, fileName);
        
        this.fullscreenLoading = false;
        this.$message.success('Excel导出成功');
        
      } catch (error) {
        console.error('生成Excel文件失败:', error);
        this.$message.error('Excel导出失败');
        this.fullscreenLoading = false;
      }
    },

    // 检查字符串是否包含中文字符
    isChinese(str) {
      return /[\u4e00-\u9fff]/.test(str);
    },

    // 解析HTML模板，提取表头结构
    parseHtmlTemplate() {
      try {
        let str = this.gyHtml;
        
        // Base64解码
        if (str && typeof str === 'string') {
          try {
            str = this.safeBase64Decode(str);
          } catch (decodeError) {
            console.error('Base64 解码失败:', decodeError);
            str = this.gyHtml;
          }
        }

        // 处理国际化标签
        let reg1 = /\[[^\]]*\]/g;
        str.match(reg1) &&
          str.match(reg1).map(code => {
            let c = code.replace('[', '');
            c = c.replace(']', '');
            str = str.replace(code, this.$t(c));
          });

        // 创建临时DOM元素来解析HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = str;
        
        const tables = tempDiv.querySelectorAll('table');
        const allDataColumns = [];
        
        tables.forEach((table, tableIndex) => {
          const rows = Array.from(table.querySelectorAll('tr'));
          if (rows.length === 0) return;
          
          // 检查第一列是否包含中文（除表头外）
          let hasChineseInFirstColumn = false;
          let firstDataRowIndex = -1;
          
          // 找到第一个数据行（包含code属性的行）
          for (let i = 0; i < rows.length; i++) {
            const cells = rows[i].querySelectorAll('td');
            const hasCode = Array.from(cells).some(cell => cell.getAttribute('code'));
            if (hasCode) {
              firstDataRowIndex = i;
              break;
            }
          }
          
          // 检查第一列是否包含中文
          if (firstDataRowIndex !== -1) {
            for (let i = firstDataRowIndex; i < rows.length; i++) {
              const cells = rows[i].querySelectorAll('td');
              if (cells.length > 0) {
                const firstCellText = cells[0].textContent || cells[0].innerText || '';
                if (this.isChinese(firstCellText.trim())) {
                  hasChineseInFirstColumn = true;
                  break;
                }
              }
            }
          }
          
          if (hasChineseInFirstColumn) {
            // 情况1：第一列包含中文，需要组合表头
            this.parseTableWithChineseExplanations(table, allDataColumns);
          } else {
            // 情况2：第一列不包含中文，使用简单表头
            this.parseSimpleTable(table, allDataColumns);
          }
        });
        
        return allDataColumns;
        
      } catch (error) {
        console.error('解析HTML模板失败:', error);
        return [];
      }
    },

    // 解析包含中文释义的表格
    parseTableWithChineseExplanations(table, allDataColumns) {
      const rows = Array.from(table.querySelectorAll('tr'));
      if (rows.length < 2) return;
      
      // 获取表头行（第一行）
      const headerRow = rows[0];
      const headerCells = headerRow.querySelectorAll('td');
      
      // 获取表格的主标题（第一行第一列）
      const mainTitle = headerCells[0] ? (headerCells[0].textContent || headerCells[0].innerText || '').trim() : '';
      
      // 获取数据行
      const dataRows = rows.slice(1);
      
      // 提取列标题（除第一列外的所有列）
      const columnHeaders = [];
      for (let i = 1; i < headerCells.length; i++) {
        const headerText = headerCells[i].textContent || headerCells[i].innerText || '';
        columnHeaders.push(headerText.trim());
      }
      
      // 处理每个数据行
      dataRows.forEach(dataRow => {
        const cells = dataRow.querySelectorAll('td');
        if (cells.length === 0) return;
        
        // 获取第一列的中文释义
        const explanation = cells[0].textContent || cells[0].innerText || '';
        const explanationText = explanation.trim();
        
        // 如果第一列不是中文，跳过这一行
        if (!this.isChinese(explanationText)) {
          return;
        }
        
        // 处理其他列
        for (let i = 1; i < cells.length; i++) {
          const cell = cells[i];
          const code = cell.getAttribute('code');
          
          if (code) {
            // 组合表头：主标题 + 列标题 + 中文释义
            const columnHeader = columnHeaders[i - 1] || '';
            let combinedHeader = '';
            
            // 添加主标题（如果存在）
            if (mainTitle) {
              combinedHeader += mainTitle;
            }
            
            // 添加列标题
            combinedHeader += columnHeader;
            
            // 添加中文释义
            combinedHeader += explanationText;
            
            allDataColumns.push({
              text: combinedHeader,
              code: code,
              isData: true
            });
          }
        }
      });
    },

    // 解析简单表格（第一列不包含中文）
    parseSimpleTable(table, allDataColumns) {
      const rows = Array.from(table.querySelectorAll('tr'));
      if (rows.length < 2) return;
      
      // 获取表头行（第一行）
      const headerRow = rows[0];
      const headerCells = headerRow.querySelectorAll('td');
      
      // 获取数据行（包含code属性的行）
      const dataRows = rows.filter(row => {
        const cells = row.querySelectorAll('td');
        return Array.from(cells).some(cell => cell.getAttribute('code'));
      });
      
      if (dataRows.length === 0) return;
      
      // 使用第一行数据来获取列信息
      const firstDataRow = dataRows[0];
      const dataCells = firstDataRow.querySelectorAll('td');
      
      dataCells.forEach((cell, index) => {
        const code = cell.getAttribute('code');
        if (code) {
          // 获取对应的表头
          let headerText = '';
          if (headerCells[index]) {
            headerText = headerCells[index].textContent || headerCells[index].innerText || '';
            headerText = headerText.trim();
          }
          
          allDataColumns.push({
            text: headerText,
            code: code,
            isData: true
          });
        }
      });
    },

    // 根据模板生成Excel数据
    generateExcelDataFromTemplate(templateData) {
      try {
        const excelData = [];
        
        // 首先构建表头行
        const headerRow = ['设备名称', '模号', '料号', '生产时间'];
        
        // 从模板中提取所有数据列的表头
        const dataColumns = [];
        templateData.forEach(cell => {
          if (cell.isData && cell.code) {
            // 这是数据列，记录表头信息
            dataColumns.push({
              header: cell.text,
              code: cell.code
            });
          }
        });
        
        // 将数据列的表头添加到总表头
        dataColumns.forEach(col => {
          headerRow.push(col.header);
        });
        
        // 将表头作为第一行
        excelData.push(headerRow);
        
        // 为每个监控数据记录生成一行
        this.info.singleMonitorDatas.forEach((monitorData, dataIndex) => {
          const rowData = [];
          
          // 添加基本信息列
          rowData.push(this.info.equipment.name); // 设备名称
          rowData.push(monitorData.mouldNo || ''); // 模号
          rowData.push(monitorData.materialNo || ''); // 料号
          rowData.push(this.dayjs(monitorData.time).format('YYYY-MM-DD HH:mm:ss')); // 生产时间
          
          // 添加数据列的值
          dataColumns.forEach(col => {
            let value = monitorData.data[col.code];
            
            if (value == null) {
              rowData.push('');
            } else {
              // 处理字典类型数据
              const eqPoint = this.store.state.eqPoints[this.info.equipmentId] && this.store.state.eqPoints[this.info.equipmentId][col.code];
              const dictTypeCode = eqPoint && eqPoint.dictTypeCode;
              if (dictTypeCode != null && dictTypeCode !== '') {
                value = this.$t(this.store.state.dictJsonAll[dictTypeCode][parseInt(value)]);
              } else {
                // 处理数值类型
                const dataType = eqPoint && eqPoint.dataType;
                if (dataType == 1) {
                  // 字符串类型
                  value = value;
                } else if (dataType == 3) {
                  // 整数类型
                  value = isNaN(Number(value)) ? value : Number(value).toFixed(0);
                } else {
                  // 小数类型
                  const prec = eqPoint && eqPoint.prec;
                  value = isNaN(Number(value)) ? value : Number(value).toFixed(prec == null ? 2 : prec);
                }
              }
              rowData.push(value);
            }
          });
          
          excelData.push(rowData);
        });
        
        return excelData;
        
      } catch (error) {
        console.error('生成Excel数据失败:', error);
        return [];
      }
    },

    // 计算列宽
    calculateColumnWidths(data) {
      if (!data || data.length === 0) return [];
      
      const maxCols = Math.max(...data.map(row => row.length));
      const colWidths = [];
      
      for (let i = 0; i < maxCols; i++) {
        let maxWidth = 10; // 最小宽度
        
        data.forEach(row => {
          if (row[i]) {
            const cellLength = String(row[i]).length;
            maxWidth = Math.max(maxWidth, Math.min(cellLength + 2, 50)); // 最大宽度50
          }
        });
        
        colWidths.push({ wch: maxWidth });
      }
      
      return colWidths;
    },

    // 批量导出pdf
    exportPdfBatch(row) {
      this.info = row;
      // 先拿到设备工艺模板
      this.exportPdfLoading = true;
      this.fullscreenLoading = true; // 显示全屏loading
      this.progressText = '正在获取工艺模板...';

      this.http.get('/web/craft/snapshot/export/template?equipmentId=' + row.equipmentId).then(res => {
        // 验证返回的数据
        if (!res.data || !res.data.gy) {
          this.$message.error('获取工艺模板失败：模板数据为空');
          this.fullscreenLoading = false; // 关闭loading锁屏
          return;
        }

        this.gyHtml = res.data.gy;
        this.progressText = '正在解析监控数据...';

        // 验证 singleMonitorDatas 数据
        try {
          this.$set(this.info, 'singleMonitorDatas', JSON.parse(this.info.dataJson));
        } catch (parseError) {
          console.error('解析 dataJson 失败:', parseError);
          this.$message.error('解析监控数据失败');
          this.fullscreenLoading = false; // 关闭loading锁屏
          return;
        }

        this.$nextTick(() => {
          this.isPrinting = true;
          this.progressText = '正在准备生成PDF...';

          // 等待 DOM 更新完成后执行导出
          setTimeout(() => {
            this.generatePdfOptimizedBatch();
          }, 5000);
        });

      }).catch(err => {
        console.error('获取工艺模板失败:', err);
        this.$message.error(this.$t(err));
        this.fullscreenLoading = false; // 关闭loading锁屏
      }).finally(() => {
        this.exportPdfLoading = false;
      });
    },

    // 批量生成PDF（优化版本 - 分批处理）
    generatePdfOptimizedBatch() {
      const totalItems = this.info.singleMonitorDatas.length;
      const batchSize = 51; // 每批处理51个
      const totalBatches = Math.ceil(totalItems / batchSize);

      console.log(`总数据量: ${totalItems}, 每批处理: ${batchSize}, 总批次: ${totalBatches}`);

      // 设置loading锁屏和进度信息
      this.fullscreenLoading = true;
      this.currentBatch = 0;
      this.totalBatches = totalBatches;
      this.progressText = `正在准备生成PDF... (0/${totalBatches} 批)`;

      // 创建单个PDF文档
      const pdf = new jsPDF('l', 'mm', 'a4');
      let currentPageIndex = 0; // 跟踪当前PDF中的页面索引

      // 开始处理第一批
      this.processBatchToSinglePdf(0, totalBatches, batchSize, totalItems, pdf, currentPageIndex);
    },

    // 递归处理每个批次，添加到同一个PDF
    processBatchToSinglePdf(currentBatch, totalBatches, batchSize, totalItems, pdf, currentPageIndex) {
      if (currentBatch >= totalBatches) {
        // 所有批次处理完成，下载PDF
        const fileName = `工艺快照_批量优化版_${this.info.equipment.name}_${new Date().getTime()}.pdf`;
        pdf.save(fileName);
        this.isPrinting = false;
        this.fullscreenLoading = false; // 关闭loading锁屏
        this.$message.success('批量PDF导出成功');
        return;
      }

      const startIndex = currentBatch * batchSize;
      const endIndex = Math.min((currentBatch + 1) * batchSize, totalItems);
      const currentBatchItems = this.info.singleMonitorDatas.slice(startIndex, endIndex);

      console.log(`正在处理第 ${currentBatch + 1} 批 (${startIndex + 1} - ${endIndex} 条)`);

      // 更新进度信息
      this.currentBatch = currentBatch + 1;
      this.progressText = `正在处理第 ${this.currentBatch}/${totalBatches} 批... (${startIndex + 1}-${endIndex}/${totalItems} 条数据)`;

      // 临时修改 singleMonitorDatas 为当前批次的数据
      const originalSingleMonitorDatas = this.info.singleMonitorDatas;
      this.$set(this.info, 'singleMonitorDatas', currentBatchItems);

      this.$nextTick(() => {
        // 等待 DOM 更新
        setTimeout(() => {
          // 获取整个容器元素
          const containerElement = document.getElementById('gykzpldc');

          if (!containerElement) {
            this.$message.error('导出元素不存在');
            this.fullscreenLoading = false; // 关闭loading锁屏
            return;
          }

          // 使用 html2canvas 将整个容器转换为 canvas
          html2canvas(containerElement, {
            scale: 1,
            dpi: 300, // 处理模糊问题
          }).then(canvas => {
            // 恢复原始的 singleMonitorDatas
            this.$set(this.info, 'singleMonitorDatas', originalSingleMonitorDatas);

            // 计算每页的高度（像素）
            const heightPerPage = Math.floor(canvas.height / currentBatchItems.length);
            console.log(`第 ${currentBatch + 1} 批每页高度(像素):`, heightPerPage);

            // 为每个 singleMonitorDatas 项创建一页
            for (let j = 0; j < currentBatchItems.length; j++) {
              console.log(`第 ${currentBatch + 1} 批第 ${j + 1} 页...`);

              // 如果不是第一页，添加新页面
              if (currentPageIndex > 0) {
                pdf.addPage();
              }

              // 计算当前页在 canvas 中的位置
              const sourceY = j * heightPerPage;
              const sourceHeight = heightPerPage;

              console.log(`第 ${currentBatch + 1} 批第 ${j + 1} 页 - sourceY: ${sourceY}, sourceHeight: ${sourceHeight}`);

              // 创建临时 canvas 来截取当前页的内容
              const tempCanvas = document.createElement('canvas');
              const tempCtx = tempCanvas.getContext('2d');
              tempCanvas.width = canvas.width;
              tempCanvas.height = sourceHeight;

              // 将原 canvas 的对应部分绘制到临时 canvas
              tempCtx.drawImage(
                canvas,
                0, sourceY, canvas.width, sourceHeight,
                0, 0, canvas.width, sourceHeight
              );

              // 将临时 canvas 转换为 JPEG
              const imgData = tempCanvas.toDataURL('image/jpeg', 0.8);

              // A4 横向纸张尺寸 (mm)
              const a4Width = 297; // A4 横向纸宽度 (mm)
              const a4Height = 210; // A4 横向纸高度 (mm)
              const a4Ratio = a4Width / a4Height; // A4 横向宽高比

              // 计算内容的宽高比
              const contentWidth = tempCanvas.width;
              const contentHeight = tempCanvas.height;
              const contentRatio = contentWidth / contentHeight;

              // 根据宽高比决定缩放策略
              let imgWidth, imgHeight;

              if (contentRatio > a4Ratio) {
                // 内容比A4横向更宽，以宽度100%为准，高度按比例缩放
                imgWidth = a4Width;
                imgHeight = a4Width / contentRatio;
                console.log(`第 ${currentBatch + 1} 批第 ${j + 1} 页 - 内容较宽，以宽度为准缩放: ${imgWidth}mm × ${imgHeight}mm`);
              } else {
                // 内容比A4横向更高，以高度100%为准，宽度按比例缩放
                imgHeight = a4Height;
                imgWidth = a4Height * contentRatio;
                console.log(`第 ${currentBatch + 1} 批第 ${j + 1} 页 - 内容较高，以高度为准缩放: ${imgWidth}mm × ${imgHeight}mm`);
              }

              // 计算居中位置
              const offsetX = (a4Width - imgWidth) / 2;
              const offsetY = (a4Height - imgHeight) / 2;

              // 将图片添加到 PDF，使用计算出的尺寸和位置
              pdf.addImage(imgData, 'JPEG', offsetX, offsetY, imgWidth, imgHeight);

              console.log(`第 ${currentBatch + 1} 批第 ${j + 1} 页已添加到 PDF (总第 ${currentPageIndex + 1} 页)`);
              currentPageIndex++;
            }

            console.log(`第 ${currentBatch + 1} 批处理完成，当前PDF总页数: ${currentPageIndex}`);

            // 处理下一批
            this.processBatchToSinglePdf(currentBatch + 1, totalBatches, batchSize, totalItems, pdf, currentPageIndex);

          }).catch(error => {
            console.error('html2canvas 执行失败:', error);
            this.$message.error('PDF导出失败');
            this.isPrinting = false;
            this.fullscreenLoading = false; // 关闭loading锁屏
          });
        }, 1000); // 等待1秒确保DOM更新
      });
    }
  }
};
</script>
